import { render, staticRenderFns } from "./ViewShareModal.vue?vue&type=template&id=392ecdfd"
import script from "./ViewShareModal.vue?vue&type=script&lang=ts"
export * from "./ViewShareModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('392ecdfd')) {
      api.createRecord('392ecdfd', component.options)
    } else {
      api.reload('392ecdfd', component.options)
    }
    module.hot.accept("./ViewShareModal.vue?vue&type=template&id=392ecdfd", function () {
      api.rerender('392ecdfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/ViewShareModal.vue"
export default component.exports